import Plan from "./PromoPlan";
import { useEffect, useState } from "react"
import InfoModal from "../modals/InfoModal";
import StackedTitle from "../form_titles/StackedTitle";


import RocketImage from "../../img/RCKT-EMV-Mobile-Dongle-2.png"
import VirtualImage from "../../img/Virtual_Terminal.png"
import handheldImage from "../../img/Valor_VL110_Handheld-POS_angle_2.1.png"
import androidImage from "../../img/VL500_Android_POS_3.1.png"


export default function Plans(props) {

    const [rocketImage, setRocketImage] = useState(RocketImage)

    return (
        <div className = "bg-white rounded-lg shadow my-10 mb-20">
            <section className="text-gray-600 body-font overflow-hidden">
                <div className="container px-5 py-24 mx-auto">
                    <div className="flex flex-col text-center w-full mb-5">
                        <h1 className="sm:text-4xl text-3xl font-medium title-font mb-2 text-gray-900">Terminals</h1>
                        <p className="lg:w-2/3 mx-auto leading-relaxed text-2xl text-gray-500">We want what is best for you.</p>
                    </div>
                    <div className="flex flex-wrap -m-4">
                        <Plan
                            color = {props.color}
                            name = "RCKT Mobile"
                            cost = "$25"
                            image = {RocketImage}
                            features = {["Pairs Instantly with Mobile Device", "EMV Contact /Contactless", "Embedded NFC Reader",
                            "Compatible with IOS & Android", "Accepts Pin Debit and EBT", "Cash Discount & Surcharge Programs"]}
                            buttonTxt = "Order Now"
                            popular = {false}
                            values = {props.values}
                            changeVal = {props.changeVal}
                            nextStep = {props.nextStep}
                        />
                        <Plan
                            color = {props.color}
                            name = "VL110 Counter Top Terminal"
                            cost = "$250"
                            image = {handheldImage}
                            features = {["Countertop POS", "Great for retail and restaurants", "Ethernet, Wi-Fi Connectivity",
                            "Large Scale Touch Screen Display", "Signature Capture", "Both Cash Discount & Surcharge Compatible"]}
                            buttonTxt = "Order Now"
                            popular = {true}
                            card = "Popular"
                            values = {props.values}
                            changeVal = {props.changeVal}
                            nextStep = {props.nextStep}
                        />
                        <Plan
                            color = {props.color}
                            name = "VL500 Wireless Android Terminal"
                            cost = "$275"
                            image = {androidImage}
                            features = {["4G & Wi-Fi Connectivity", "Bill Splitting", "Cash Discounting & Surcharging on Tip", "Digital Receipts",
                            "Contactless Payment", "EMV Contact / Contactless", "Customizable Menu & Inventory"]}
                            buttonTxt = "Order Now"
                            popular = {false}
                            values = {props.values}
                            changeVal = {props.changeVal}
                            nextStep = {props.nextStep}
                        />
                        <Plan
                            color = {props.color}
                            name = "Cloud Based Portal - Virtual Terminal"
                            cost = "$10/mo"
                            image = {VirtualImage}
                            features = {["Dynamic Transaction Descriptor", "Tokenized Payments", "E invoice Text to Pay & Email to Pay", 
                            "Pay Now Link Hosted Payment Page", "E-commerce Integrations", "Recurring Payments"]}
                            buttonTxt = "Order Now"
                            popular = {false}
                            values = {props.values}
                            changeVal = {props.changeVal}
                            nextStep = {props.nextStep}
                        />
                    </div>
                </div>
            </section>


        </div>
    )
}